
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"4","y":"6","width":"16","height":"15","rx":"1","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill":"#593289","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round","d":"M3 6h18v3H3z"}}),_c('path',{attrs:{"d":"M17 12l-1.051-6.516c-.723-4.485-7.175-4.485-7.898 0L7 12","stroke":"#593289","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17 12l-1.051-6.516c-.723-4.485-7.175-4.485-7.898 0L7 12","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    